import React, { useState, useEffect, useContext } from "react";

import styled from "styled-components";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import Chip from "@mui/material/Chip";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import { action as actionVar } from "variables/action";
import { targetedusageList } from "variables/lists/action";
import { ActionContext } from "context/ActionContext";
import {
  AutocompleteMultiselectCheckbox,
  MultiselectCheckbox,
  CustomSelect,
  IntInput,
} from "components/Input/Index.js";
import useActionTable from "./useActionTable.js";

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const RTTargetFluid = ({ planActionId, planActionName }) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [editableRowId, setEditableRowId] = useState(false);

  const [newData, setNewData] = useState([]);

  console.log(newData);

  const classes = useStyles();

  useEffect(() => {
    setNewData(gridState.data);
  }, [gridState.data]);

  function indexFinder(rowId) {
    const indexOfId = newData.findIndex((obj) => obj.id == rowId);

    return indexOfId;
  }
  const columns = [
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (row.name !== undefined ? row.name : row.value),
    },
  ];

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    const indexOfId = newData.findIndex((obj) => obj.id == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;

    setNewData(newArray);
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters.impact,
          targetedenergy: newArray,
        },
      },
    }));
  };

  const handleSelectedChange = ({ selectedRows }) => {
    if (actionplanupdate) {
      selectedRows.map((wall) => (wall.isSelected = true));
      let engineeringstudyedelements =
        action.parameters?.impact?.engineeringstudyedelements;
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: {
            ...prevState.parameters?.impact,
            [engineeringstudyedelements]: selectedRows,
          },
        },
      }));
    }
  };

  const selectableRowDisabled = (row) => {
    if (!actionplanupdate) {
      return row;
    }
  };

  const rowSelectCritera = (row) => row.isSelected == true;
  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noHeader={true}
        //title="Selection des parois"
        noDataComponent="Aucun élément selectionné"
        columns={columns}
        subHeader
        persistTableHead
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        selectableRows
        onSelectedRowsChange={handleSelectedChange}
        selectableRowSelected={rowSelectCritera}
        selectableRowsHighlight
        selectableRowDisabled={selectableRowDisabled}
        {...gridState}
      />
    </>
  );
};

export default RTTargetFluid;
